import { useQuery } from '@tanstack/react-query';
import { bookingPublicSummaryRoute } from '@/features/public/bookingSummary/routes/bookingPublicSummaryRoute.ts';
import BookingSummaryHeader from '@/features/public/bookingSummary/components/BookingSummaryHeader.tsx';
import ParticipantsPriceCard from '@/features/public/bookingSummary/components/ParticipantsPriceCard.tsx';
import InstallmentsCard from '@/features/public/bookingSummary/components/InstallmentsCard.tsx';
import ChatLinkCard from '@/features/public/bookingSummary/components/ChatLinkCard.tsx';
import AcceptedConsentsCard from '@/features/public/bookingSummary/components/AcceptedConsentsCard.tsx';
import { getBookingSummaryQueryOptions } from '@/features/public/bookingSummary/hooks/useGetBookingSummary.ts';
import PendingChangeSection from '@/features/public/bookingSummary/components/PendingChangeSection.tsx';

const BookingPublicSummaryPage = () => {
  const { bookingSummary: initialBookingSummary } =
    bookingPublicSummaryRoute.useLoaderData();
  const { orgSlug } = bookingPublicSummaryRoute.useParams();
  const { token } = bookingPublicSummaryRoute.useSearch();

  const { data: bookingSummary = initialBookingSummary } = useQuery({
    ...getBookingSummaryQueryOptions(orgSlug, token),
    initialData: initialBookingSummary,
  });

  return (
    <div className="min-h-screen py-8">
      <div className="mx-auto flex max-w-2xl flex-col gap-2 px-4">
        <BookingSummaryHeader data={bookingSummary} />
        {/* Zmiany czekające na zgodę stoją nad rachunkiem — jako jedyne na tej
            stronie wymagają decyzji, a reszta opisuje stan sprzed nich. */}
        <PendingChangeSection
          orgSlug={orgSlug}
          token={token}
          participants={bookingSummary.participants}
          client={bookingSummary.client}
        />
        <ParticipantsPriceCard data={bookingSummary} />
        <InstallmentsCard
          installments={bookingSummary.installments}
          orgSlug={orgSlug}
          token={token}
          transferAccounts={bookingSummary.transferAccounts}
          cashInstruction={bookingSummary.cashInstruction}
          transactionRef={bookingSummary.transactionRef}
        />
        {bookingSummary.consents?.length > 0 && (
          <AcceptedConsentsCard
            consents={bookingSummary.consents}
            orgSlug={orgSlug}
            token={token}
            organizerName={bookingSummary.organizerName}
            bookingStatus={bookingSummary.bookingStatus}
          />
        )}
        {bookingSummary.chatLink && (
          <ChatLinkCard chatLink={bookingSummary.chatLink} />
        )}
      </div>
    </div>
  );
};

export default BookingPublicSummaryPage;
